import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { throwError } from 'rxjs';
import {
  catchError,
  delay,
  finalize,
  map,
  retry,
  share,
  shareReplay,
  takeUntil,
  tap,
} from 'rxjs/operators';

import { Location } from '@angular/common';
import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import { CampaignInfoService } from 'src/app/core/services/campaign-info.service';
import { EventTypes } from '../../../core//constants/event-types';
import {
  CustomResult,
  CustomResultOfGetScheduledMessageCalculationByIdDto,
  CustomResultOfGetScheduledMessageCalculationsDto,
  GetScheduledMessageCalculationByIdQuery,
  SendTypes,
  SocialMediaSendDetailModel,
  UseTypes,
  VoiceMessageDetailsRequest,
} from '../../../core/api/models';
import { SendSubTypes } from '../../../core/api/models/send-sub-types';
import { UpdateScheduledMessageCommand } from '../../../core/api/models/update-scheduled-message-command';
import { AppDomService } from '../../../core/services/dom.service';
import { DynamicTabService } from '../../../core/services/dynamic-tab.service';
import { UtilityService } from '../../../core/services/utility.service';
import { BaseFormPageComponent } from '../../shared/base/components/base-form-page.component';
import {
  BaseSendSms,
  BaseSendSmsConfig,
} from '../base/base-send-sms/base-send-sms.component';
import { CampaignsFormComponent } from '../campaigns/campaigns-form/campaigns-form.component';
import { SendSmsConfirmationComponent } from '../send-sms-confirmation/send-sms-confirmation.component';
import { CreateFastScheduledMessageCommand } from './../../../core/api/models/create-fast-scheduled-message-command';
import { CreateScheduledMessageCommand } from './../../../core/api/models/create-scheduled-message-command';
import { GetScheduledMessageByIdDto } from './../../../core/api/models/get-scheduled-message-by-id-dto';
import { GetScheduledMessageCalculationsDto } from './../../../core/api/models/get-scheduled-message-calculations-dto';
import { GetScheduledMessageCalculationsQuery } from './../../../core/api/models/get-scheduled-message-calculations-query';
import { PrivateNumbersService } from './../../../core/api/services/private-numbers.service';
import { ScheduledMessagesService } from './../../../core/api/services/scheduled-messages.service';
import { SendDateTimeType } from './../../../core/enums/send-date-time-type.enum';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import {
  DialogService,
  DialogStatus,
} from './../../../core/services/dialog.service';
import { TabsDynamicComponent } from './../../../layout/components/tabs-dynamic/tabs-dynamic.component';
import { SendSmsService } from './send-sms.service';

@Component({
  selector: 'app-send-sms',
  templateUrl: './send-sms.component.html',
  styleUrls: ['../base/base-sending-system.component.scss'],
  standalone: false,
})
export class SendSmsComponent
  extends BaseFormPageComponent
  implements OnInit, OnDestroy
{
  //#region properties

  tabName: string = 'sendSMS';
  title: string = '';

  model: CreateScheduledMessageCommand = {};
  formPageConfig: FormPageConfig<GetScheduledMessageByIdDto> = {};
  baseSendSmsConfig: BaseSendSmsConfig;
  fastSendReceivers: string;
  smsCount: number;
  privateNumber: string;

  //for edit
  receiversForDelete: string;
  receiversForAdd: string;
  maxReceiversForAdd = 50000;
  maxReceiversForDelete = 400000;

  fastSendLoading: boolean;
  calcLoading: boolean;
  sendLoading: boolean;
  isUploadFileToServer: boolean = true;
  isTwilioNumber?: boolean;

  location = inject(Location);
  //#endregion

  constructor(
    protected currentService: ScheduledMessagesService,
    public dialogService: DialogService,
    public utilityService: UtilityService,
    protected translate: TranslateService,
    public dynamicTabService: DynamicTabService,
    public privateNumberService: PrivateNumbersService,
    private tabsDynamicComponent: TabsDynamicComponent
  ) {
    super();
    this.baseCreateGetApiForSend(
      this.currentService,
      'scheduledMessagesCreateGet'
    );
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.privateNumber = this.formPageConfig?.editData?.senderNumber;
      this.pageVocabs = 'pages.sendSMS.';
      this.fields = 'pages.sendSMS.fields.';

      this.configBaseSendSMS();

      if (CampaignInfoService.lastCampaignInfo.id) {
        this.location.go(
          window.location.pathname +
            '?' +
            QueryStringTypesEnum.Campaign_key +
            '=' +
            CampaignInfoService.lastCampaignInfo.id
        );
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  closeThisTab() {
    try {
      const TimeOut = setTimeout(() => {
        this.tabsDynamicComponent.manualCloseTab(this.tabName);
        clearTimeout(TimeOut);
      }, 50);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  initModel() {
    if (!this.formPageConfig?.isEditMode) {
      this.model.voiceMessageDetails = {};
      this.model.socialMediaDetails = {};
    } else if (this.formPageConfig?.isEditMode) {
      //مقدار ارسال صوتی رو پر میکنه
      if (this.formPageConfig?.editData?.voiceMessageDetails)
        this.model.voiceMessageDetails = Object.assign(
          {},
          this.formPageConfig.editData.voiceMessageDetails
        );
      //مقدار ارسال مدیا رو پر میکنه
      else if (this.formPageConfig?.editData?.socialMediaFileId)
        this.model.socialMediaDetails = {
          socialMediaApplicationId:
            this.formPageConfig?.editData?.socialMediaApplicationId,
          socialMediaFileId: this.formPageConfig?.editData?.socialMediaFileId,
        };
    }
  }

  configBaseSendSMS() {
    try {
      this.baseSendSmsConfig = {
        title: this.formPageConfig.isEditMode
          ? this.pageVocabs + 'editTitle'
          : this.pageVocabs + 'title',
        isEdit: this.formPageConfig.isEditMode,
        isShowPageHeader: true,
        isShowCampaign: true,
        msgInfoClassList: 'md:tw-w-1/2 xl:tw-w-1/3 tw-mt-2 send-sms',
        receiversClassList: 'md:tw-w-1/2 xl:tw-w-1/3 tw-mt-2 send-sms',
        sendDateTimeClassList: 'md:tw-w-1/2 xl:tw-w-1/3 tw-mt-2 send-sms',
        isShowExtraReceivers: false,
        isAddSignature: !this.formPageConfig?.isEditMode ? true : false,
        isAddHeader: !this.formPageConfig?.isEditMode ? true : false,
        sendType: SendTypes.Single,
        useType: UseTypes.Normal,
        isShowReceivers: !this.formPageConfig.isEditMode
          ? true
          : this.formPageConfig.editData.sendSubType == SendSubTypes.Direct
          ? true
          : false,
        isShowFastSend: this.formPageConfig.isEditMode ? false : true,
      };
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  initForm() {
    this.form = new FormGroup({
      receiversInformation: new FormGroup({
        receivers: new FormControl(''),
        receiversForDelete: new FormControl(''),
        receiversForAdd: new FormControl(''),
      }),
    });
  }
  //#region Api

  //create
  baseCreateApi(model: CreateScheduledMessageCommand) {
    this.unSubs();
    this.sendLoading = true;
    this.loading = true;

    SendSmsService.sendSmsId = Math.random()
      .toString(36)
      .substring(2, 20 + 2);

    const subscription = this.currentService
      .scheduledMessagesCreatePost({ body: model })
      .pipe(
        share(),
        takeUntil(this.onDestroy$),
        retry(0),
        finalize(() => {
          this.sendLoading = false;
          this.loading = false;
        }),
        catchError((error: any) => {
          this.sendLoading = false;
          this.loading = false;
          subscription.unsubscribe();
          return throwError(() => error);
        }),
        shareReplay(1)
      )
      .subscribe((result: CustomResult) => {
        this.apiNotificationService.notifyMessage({
          result,
          mode: 'matDialog',
        });
        if (result.isSucceed) {
          this.onSuccess();
          this.refreshPage();
        }
      });
  }

  //update
  baseUpdateApi() {
    this.unSubs();
    this.sendLoading = true;
    this.loading = true;
    const model: UpdateScheduledMessageCommand = {
      id: this.formPageConfig.editData?.id,
      receiversForAdd: this.receiversForAdd,
      receiversForDelete: this.receiversForDelete,
      smsText: this.model.smsBody,
      privateNumberId: this.model.senderNumberId,
      description: this.model.description,
      isFlashSms: this.model?.isFlashSms,
      //direct
      sendDateTime: this.model.sendDateTime,
      // period
      sendPeriodChecked: this.model.sendPeriodChecked,
      periodTypeValue: this.model.periodTypeValue,
      periodEnd: this.model.periodEnd,
      periodStart: this.model.periodStart,
      periodText: this.model.periodText,
      // gradual
      gradualChecked: this.model.gradualChecked,
      gradualPageSize: this.model.gradualPageSize,
      gradualPeriodText: this.model.gradualPeriodText,
      gradualStart: this.model.gradualStart,
      sendDateTimeChecked: this.model.sendDateTimeChecked,
      voiceMessageDetails: this.model.voiceMessageDetails,
      socialMediaDetails: this.model?.socialMediaDetails,
    };

    this.currentService
      .scheduledMessagesUpdatePut({ body: model })
      .pipe(
        this.basePipeOperators(),
        finalize(() => (this.sendLoading = false))
      )
      .subscribe((result) => {
        this.apiNotificationService.notifyMessage({
          result,
          mode: 'matDialog',
        });
        if (result?.isSucceed) this.onSuccess();
      });
  }
  GetScheduleMessageCalculationsApi(
    model: GetScheduledMessageCalculationByIdQuery
  ) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .scheduledMessagesGetScheduledMessageCalculationById({ body: model })
      .pipe(
        map((res: CustomResultOfGetScheduledMessageCalculationByIdDto) => {
          if (res.isSucceed) this.onConfirmation(res?.data);
        }),
        this.basePipeOperators()
      )
      .subscribe();
  }

  //fast Send
  fastScheduledMessageApi(model: CreateFastScheduledMessageCommand) {
    this.unSubs();

    this.fastSendLoading = true;
    this.sendLoading = true;

    this.currentService
      .scheduledMessagesCreateFastScheduledMessagePost({ body: model })
      .pipe(
        finalize(
          () => ((this.fastSendLoading = false), (this.sendLoading = false))
        ),
        takeUntil(this.onDestroy$)
      )
      .subscribe((result) => {
        this.apiNotificationService.notifyMessage({
          result,
          mode: 'matDialog',
        });
        this.refreshPage();
      });
  }

  //calculations
  scheduledMessageCalculationsApi(model: GetScheduledMessageCalculationsQuery) {
    this.unSubs();
    this.calcLoading = true;
    this.loading = true;

    this.currentService
      .scheduledMessagesGetScheduledMessageCalculations({ body: model })
      .pipe(
        delay(500),
        tap((res: CustomResultOfGetScheduledMessageCalculationsDto) => {
          if (res.isSucceed) this.onConfirmation(res?.data);
        }),
        this.basePipeOperators(),

        finalize(() => (this.calcLoading = false))
      )
      .subscribe();
  }

  //#endregion

  onConfirmation(model: GetScheduledMessageCalculationsDto) {
    try {
      this.unSubs();

      let data = {
        model: model,
        sendType: SendTypes.Single,
        isEdit: this.formPageConfig.isEditMode,
        privateNumber: this.privateNumber,
      };

      const modalResult = this.dialogService.openModal({
        component: SendSmsConfirmationComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((confirm) => {
          if (confirm) {
            if (!this.formPageConfig.isEditMode) this.baseCreateApi(this.model);
            else this.baseUpdateApi();
          }
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  getBaseSendSmsModel(baseModel: BaseSendSms) {
    try {
      this.smsCount = baseModel.smsCount;
      this.model.smsBody = baseModel.finalSmsBody;
      this.model.senderNumberId = baseModel.senderNumberId;
      this.model.isSendWhiteList = baseModel.isSendWhiteList;
      this.model.isFlashSms = baseModel.isFlashSms;
      this.model.description = baseModel.description;

      this.handleVoiceMessage(
        baseModel.isCanSendVoice,
        baseModel.voiceMessageDetails
      );

      this.handleSocialMediaMessage(
        baseModel.isCanSendSocialMedia,
        baseModel.socialMediaMessageDetails
      );

      if (baseModel.campaignId) this.model.campaignId = baseModel.campaignId;

      //fast send
      this.fastSendReceivers = baseModel.fastSendReceivers;

      //direct
      this.model.sendDateTimeChecked =
        baseModel.sendDateTimeType == SendDateTimeType.DateTime ||
        baseModel.sendDateTimeType == undefined
          ? true
          : false;
      this.model.sendDateTime = baseModel.directSendDateTime;
      // period
      this.model.sendPeriodChecked =
        baseModel.sendDateTimeType == SendDateTimeType.Period ? true : false;
      this.model.periodStart = baseModel.periodicSendStartDateTime;
      this.model.periodEnd = baseModel.periodicSendEndDateTime;
      this.model.periodText = baseModel.gradualPeriodText;
      this.model.periodTypeValue = baseModel.periodTypeValue;
      this.model.isSendWhiteList = baseModel.isSendWhiteList;
      this.model.isFlashSms = baseModel.isFlashSms;

      // gradual
      this.model.gradualChecked =
        baseModel.sendDateTimeType == SendDateTimeType.Gradual ? true : false;
      this.model.gradualPageSize = baseModel.gradualPageSize;
      this.model.gradualPeriodText = baseModel.gradualPeriodText;
      this.model.gradualStart = baseModel.gradualSendDateTime;
      this.isTwilioNumber = baseModel.isTwilioNumber;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  handleVoiceMessage(
    isCanSendVoice,
    voiceMessageDetails: VoiceMessageDetailsRequest
  ) {
    try {
      if (isCanSendVoice) {
        if (voiceMessageDetails)
          this.model.voiceMessageDetails = voiceMessageDetails;

        this.model.campaignId = null;
        this.model.title = null;
        this.baseSendSmsConfig.isShowCampaign = false;
        this.baseSendSmsConfig = Object.assign({}, this.baseSendSmsConfig);
      } else {
        this.baseSendSmsConfig.isShowCampaign = true;
        this.baseSendSmsConfig = Object.assign({}, this.baseSendSmsConfig);
        if (!this.formPageConfig?.isEditMode)
          this.model.voiceMessageDetails = null;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  handleSocialMediaMessage(
    isCanSendSocialMedia,
    socialMediaMessageDetails: SocialMediaSendDetailModel
  ) {
    try {
      if (isCanSendSocialMedia) {
        if (socialMediaMessageDetails)
          this.model.socialMediaDetails = socialMediaMessageDetails;

        this.model.campaignId = null;
        this.model.title = null;
        this.baseSendSmsConfig.isShowCampaign = false;
        this.baseSendSmsConfig = Object.assign({}, this.baseSendSmsConfig);
      } else {
        this.baseSendSmsConfig.isShowCampaign = true;
        this.baseSendSmsConfig = Object.assign({}, this.baseSendSmsConfig);
        if (!this.formPageConfig?.isEditMode)
          this.model.socialMediaDetails = null;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  onFastSending() {
    this.fastScheduledMessageApi({
      receivers: this.fastSendReceivers,
      senderNumberId: this.model.senderNumberId,
      smsBody: this.model.smsBody,
      description: this.model.description,
      voiceMessageDetails: this.model.voiceMessageDetails,
      socialMediaDetails: this.model?.socialMediaDetails,
    });
  }

  emptyRecipientError() {
    this.dialogService.openDialog({
      title: 'common.error',
      message: 'common.emptyReceivers',
      status: DialogStatus.error,
    });
  }

  onSaveToCampaign(event) {
    try {
      this.model.saveToCampaign = event;

      const modalResult = this.dialogService.openModal({
        component: CampaignsFormComponent,
        data: { model: this.model, sendType: SendTypes.Single },
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          this.model.saveToCampaign = res?.isSaveAfterSend;
          if (res?.campaignId) this.model.campaignId = res?.campaignId;
          if (res?.title) this.model.title = res?.title;
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  refreshPage() {
    this.tabsDynamicComponent.refreshTab(this.tabName);
  }

  onSubmit() {
    try {
      if (
        !this.model.receivers &&
        !this.formPageConfig.isEditMode &&
        !this.isUploadFileToServer
      ) {
        this.emptyRecipientError();
        return;
      }
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;
      //edit
      if (this.formPageConfig.isEditMode) {
        this.GetScheduleMessageCalculationsApi({
          isSendWhiteList: this.model.isSendWhiteList,
          receiversForAdd: this.receiversForAdd,
          receiversForDelete: this.receiversForDelete,
          voiceMessageId: this.model.voiceMessageDetails?.voiceMessageId,
          socialMediaDetails: this.model.socialMediaDetails,
          privateNumberId: this.model.senderNumberId,
          scheduledMessageId: this.formPageConfig.editData?.id,
          smsBody: this.model.smsBody,
        });
        // this.baseUpdateApi();
        return;
      }
      if (!this.model.path)
        // calculations
        this.scheduledMessageCalculationsApi({
          receivers: this.model.receivers,
          smsBody: this.model.smsBody,
          senderNumberId: this.model.senderNumberId,
          isSendWhiteList: this.model.isSendWhiteList,
          voiceMessageId:
            this.model?.voiceMessageDetails?.voiceMessageId || null,
          socialMediaDetails: this.model?.socialMediaDetails || null,
        });
      else {
        if (!this.formPageConfig.isEditMode) this.baseCreateApi(this.model);
        else this.baseUpdateApi();
      }

      // this.baseCreateApi(this.model);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  getPrivateNumber(number: string) {
    this.privateNumber = number;
  }
}
